
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"payment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Payment"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"variant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cardNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cardHolderName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cardExpiryMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cardExpiryYear"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":131}};
    doc.loc.source = {"body":"fragment payment on Payment {\n  reference\n  variant\n  createdAt\n  cardNumber\n  cardHolderName\n  cardExpiryMonth\n  cardExpiryYear\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
